import React from 'react';
import PropTypes from 'prop-types';
import { Button, Dialog, DialogTitle, DialogActions, DialogContent, DialogContentText } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const ConfirmCancelDialog = ({ title, confirmMessage, open, handleClose, handleYes, noButtonColor, yesButtonColor }) => {
  const theme = useTheme();
  return (
    <Dialog open={open} onClose={() => handleClose()}>
      <DialogTitle id='confirm-delete'>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText>{confirmMessage}</DialogContentText>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'space-evenly', marginBottom: '20px' }}>
        <Button
          variant='contained'
          sx={[{
            width: '110px'
          }, noButtonColor ? {
            backgroundColor: noButtonColor
          } : {
            backgroundColor: theme.palette.primary.main
          }]}
          onClick={() => handleClose()}
        >
          No
        </Button>
        <Button
          variant='contained'
          sx={[{
            width: '110px'
          }, yesButtonColor ? {
            backgroundColor: yesButtonColor
          } : {
            backgroundColor: theme.palette.secondary.main
          }]}
          onClick={() => handleYes()}
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

ConfirmCancelDialog.defaultProps = {
  title: 'Confirm Cancel',
  confirmMessage: 'Would you like to save the current changes?',
};

ConfirmCancelDialog.propTypes = {
  title: PropTypes.string,
  confirmMessage: PropTypes.string,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  handleYes: PropTypes.func.isRequired,
  noButtonColor: PropTypes.string,
  yesButtonColor: PropTypes.string,
};

export default ConfirmCancelDialog;
